// Default Values
const placesState = {};
const autoCompleteInput = $(".places-autocomplete-line-1");

// Take unique Id of inputs and retrieves sibling components
const getComponents = id => ({
  street_number: {
    component: `${id}`,
    type: "long_name"
  },
  optional_line_2: {
    component: `${id}-line-2`,
    type: "long_name"
  },
  locality: {
    component: `${id}-city`,
    type: "long_name"
  },
  postal_code: {
    component: `${id}-postal`,
    type: "short_name"
  },
  administrative_area_level_1: {
    component: `${id}-state`,
    type: "short_name"
  },
  country: {
    component: `${id}-country`,
    type: "short_name"
  },
  route: {
    component: `${id}`,
    type: "long_name"
  }
});

$(document).ready(() => {
  autoCompleteInput.each((i, e) => {
    const inputId = $(e).attr("id");
    if (!placesState[inputId]) {
      placesState[inputId] = {
        autocomplete: null,
        components: getComponents(inputId)
      };
    }
  });

  // Listen's to focus event for auto complete
  autoCompleteInput.focus(e => {
    // Get the id of current focused element
    const inputId = $(e.target).attr("id");

    // Initialize autocomplete
    if (!placesState[inputId].autocomplete) {
      initAutocomplete(inputId);
    }
  });

  const initAutocomplete = id => {
    // Create the autocomplete object, restricting the search predictions to
    // geographical location types.
    placesState[id].autocomplete = new google.maps.places.Autocomplete(
      document.getElementById(id),
      {
        types: ["geocode"]
      }
    );

    // Avoid paying for data that you don't need by restricting the set of
    // place fields that are returned to just the address components.
    placesState[id].autocomplete.setFields(["address_components"]);

    // Get the place details from the autocomplete object.
    placesState[id].autocomplete.addListener("place_changed", () =>
      getAddress(id)
    );
  };

  // When user chooses an address then parse returned value to consumable values
  const getAddress = id => {
    try {
      const { address_components } = placesState[id].autocomplete.getPlace();
      Object.keys(placesState[id].components).forEach(component => {
        const container = `.${placesState[id].components[component].component}-container`;
        $(container).css({ display: "block" });
        $(container).val("");
      });

      // Get each component of the address from the place details,
      // and then fill-in the corresponding field on the form.
      address_components.forEach(place => {
        const addressType = place.types[0];

        if (placesState[id].components[addressType]) {
          const val = place[placesState[id].components[addressType].type];
          if (addressType !== "route") {
            $(`#${placesState[id].components[addressType].component}`).val(val);
          } else {
            const previousValue = $(
              `#${placesState[id].components[addressType].component}`
            ).val();
            $(`#${placesState[id].components[addressType].component}`).val(
              previousValue.concat(` ${val}`)
            );
          }
        }
      });
    } catch (e) {}
  };
});
